<template>
  <div class="delete-my-competence__form">
    <h3>Удалить Компетенции {{ competenceSet.index + 1 }}?</h3>
    <p>Вы действительно хотите удалить следующий набор компетенций?</p>

    <a-row class="form__competence-set-info">
      <a-col>
        <a-row class="form__competence-type">
          Предметная область:<span class="form__competence-name">{{
            competenceSet?.competenceSubject
              ? competenceSet?.competenceSubject.name
              : '-'
          }}</span>
        </a-row>

        <a-row class="form__competence-type">
          Технологии:<span class="form__competence-name">{{
            competenceSet?.competenceTechnology
              ? competenceSet?.competenceTechnology.name
              : '-'
          }}</span>
        </a-row>

        <a-row class="form__competence-type">
          Навыки:<span class="form__competence-name">{{
            competenceSet?.competenceSkill
              ? competenceSet?.competenceSkill.name
              : '-'
          }}</span>
        </a-row>
      </a-col>
    </a-row>

    <div class="delete-my-competence__form-button">
      <c-button-danger @click="handleDelete"> Удалить </c-button-danger>
    </div>
  </div>
</template>

<script setup>
  import { useApi } from '@/api/use-api';
  import CButtonDanger from '@/components/UI/CButtonDanger';

  const props = defineProps({
    competenceSet: Object,
  });

  const api = useApi();
  const emit = defineEmits(['close', 'update']);

  const handleDelete = async () => {
    try {
      await api.projectCompetenceSet.delete(props.competenceSet.id);
      emit('close');
      emit('update');
    } catch (error) {
      console.error('error', error);
    }
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;
  * {
    margin: 0;
  }

  .delete-my-competence__form {
    padding: 112px 17px 0 17px;

    h2 {
      font: 700 16px/22px 'Nunito Sans';
    }

    p {
      margin-top: 21px;
    }

    .form__competence-set-info {
      background: $color-bg-secondary-grey;
      border-radius: 5px;
      flex-direction: column;
      max-height: 600px;
      margin-top: 40px;
      padding: 10px 20px;

      .form__competence-type {
        color: $color-bg-status-new;
        font: 700 14px/20px 'Nunito Sans';
        margin: 20px 0;
      }

      .form__competence-name {
        font-weight: 400;
        margin-left: 10px;
        overflow: hidden;
        overflow-wrap: break-word;
      }
    }

    &-button {
      margin-top: 50px;
      text-align: right;
    }
  }
</style>
